import { color, Root } from '@amcharts/amcharts5';
import { IXYAxis } from '@amcharts/amcharts5/.internal/charts/xy/series/XYSeries';
import {
  IAxisLabelSettings,
  ICategoryAxisSettings,
  IDateAxisSettings,
  ILineSeriesSettings,
  IXYChartSettings,
} from '@amcharts/amcharts5/xy';
import { startOfHour } from 'date-fns';

import { xAxisRenderer, yAxisRenderer } from 'utils/charts/charts';
import { AxisRendererSettings } from 'utils/charts/setAxisRenderer';
import { CursorSettings } from 'utils/charts/setCursor';

export const getXYChartSettings = (): IXYChartSettings => ({
  panX: false,
  panY: false,
  wheelX: 'panX',
  wheelY: 'zoomX',
  pinchZoomX: true,
});

export const yAxisSettings = (root: Root): ICategoryAxisSettings<any> => ({
  categoryField: 'event',
  renderer: yAxisRenderer(root, {
    minGridDistance: 1,
  }),
});

export const xAxisEventsSettings = (
  root: Root,
  minDateTimeRange: string,
  maxDateTimeRange: string
): IDateAxisSettings<any> => ({
  baseInterval: {
    timeUnit: 'second',
    count: 1,
  },
  min: new Date(minDateTimeRange).getTime(),
  max: new Date(maxDateTimeRange).getTime(),
  renderer: xAxisRenderer(root, {
    strokeOpacity: 0.3,
    minGridDistance: 60,
  }),
});

export const xAxisStatusSettings = (
  root: Root,
  minDateTimeRange: string,
  maxDateTimeRange: string
): IDateAxisSettings<any> => ({
  baseInterval: {
    timeUnit: 'second',
    count: 1,
  },
  min: startOfHour(new Date(minDateTimeRange)).getTime(),
  max: new Date(maxDateTimeRange).getTime(),
  renderer: xAxisRenderer(root, {
    strokeOpacity: 0.3,
    minGridDistance: 60,
  }),
});

export const lineSeriesSettings = (
  xAxis: IXYAxis,
  yAxis: IXYAxis,
  lineColor: string
): ILineSeriesSettings => ({
  xAxis: xAxis,
  yAxis: yAxis,
  valueXField: 'time',
  categoryYField: 'event',
  sequencedInterpolation: true,
  stroke: color(lineColor),
});

export const lineSeriesSettingsStatuses = (
  xAxis: IXYAxis,
  yAxis: IXYAxis,
  lineColor: string
): ILineSeriesSettings => ({
  xAxis: xAxis,
  yAxis: yAxis,
  valueXField: 'time',
  valueYField: 'value',
  stroke: color(lineColor),
});

const fontSettings: IAxisLabelSettings = {
  fontSize: '12px',
  fontFamily: 'Inter, -apple-system, Arial, sans-serif',
};

export const yAxisRendererSettings: AxisRendererSettings = {
  labels: {
    ...fontSettings,
    fontWeight: '600',
  },
  grids: {
    visible: false,
  },
};

export const xAxisRendererSettings: AxisRendererSettings = {
  labels: {
    ...fontSettings,
  },
  grids: {
    visible: false,
  },
};

export const cursorSettings: CursorSettings = {
  cursor: {
    behavior: 'zoomX',
  },
  lineY: {
    visible: false,
  },
  lineX: {
    visible: false,
  },
};

export const cursorSettingsWithEnabledSelect = (enabledSelect: boolean): CursorSettings => ({
  cursor: {
    behavior: enabledSelect ? 'selectX' : 'none',
  },
  lineY: {
    visible: false,
  },
  lineX: {
    visible: false,
  },
});
